import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { ArrowLeft } from "lucide-react";
import { api } from "@/lib/api";
import { Seo } from "@/components/Seo";

const money = (v) => `₹${Number(v || 0).toLocaleString("en-IN")}`;

export default function AdminApplicatorPayouts() {
  const [data, setData] = useState(null);
  const load = () => api.get("/admin/applicator-payouts").then(({ data }) => setData(data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const approve = async (aid) => { try { await api.post("/admin/applicator-payouts", { applicator_id: aid }); toast.success("Payout approved & recorded"); load(); } catch (e) { toast.error(e?.response?.data?.detail || "Failed"); } };
  const markPaid = async (pid) => { await api.put(`/admin/applicator-payouts/${pid}`, { status: "PAID" }); toast.success("Marked paid"); load(); };

  if (!data) return <div className="min-h-screen bg-[#080808] flex items-center justify-center text-gray-500">Loading…</div>;
  return (
    <div className="min-h-screen bg-[#080808]" data-testid="admin-payouts-page">
      <Seo title="Admin · Applicator Payouts" description="Approve applicator payouts" />
      <div className="glass"><div className="max-w-[1000px] mx-auto px-5 h-[60px] flex items-center"><Link to="/admin/applicator-jobs" className="flex items-center gap-2 text-sm text-gray-300"><ArrowLeft size={16} /> Jobs</Link></div></div>

      <div className="max-w-[1000px] mx-auto px-5 py-10">
        <h1 className="serif-head text-3xl lg:text-4xl mb-6">Applicator Payouts</h1>

        <p className="errah-label gold-text mb-3">Payable balances</p>
        <div className="hair-border divide-y divide-white/10 mb-8" data-testid="payable-list">
          {data.payable.length === 0 && <p className="p-4 text-sm text-gray-600">No payable balances.</p>}
          {data.payable.map((p) => (
            <div key={p.applicator_id} className="p-4 flex items-center justify-between bg-white/[0.02]">
              <div><p className="text-sm">{p.name} <span className="text-xs gold-text">{p.applicator_code}</span></p><p className="text-xs text-gray-500">Payable {money(p.payable_amount)}</p></div>
              <button onClick={() => approve(p.applicator_id)} data-testid={`approve-payout-${p.applicator_code}`} className="text-xs bg-[#C9A45C] text-black px-4 py-2 font-semibold">Approve Payout</button>
            </div>
          ))}
        </div>

        <p className="errah-label gold-text mb-3">History</p>
        <div className="hair-border divide-y divide-white/10" data-testid="payout-history">
          {data.history.length === 0 && <p className="p-4 text-sm text-gray-600">No payouts yet.</p>}
          {data.history.map((p) => (
            <div key={p.id} className="p-4 flex items-center justify-between bg-white/[0.02]">
              <div><p className="text-sm">{p.applicator_id.slice(0, 12)} · {p.status}</p><p className="text-xs text-gray-500">{p.created_at?.slice(0, 10)}</p></div>
              <div className="flex items-center gap-3">
                <p className="font-display gold-text">{money(p.amount)}</p>
                {p.status !== "PAID" && <button onClick={() => markPaid(p.id)} className="text-xs border border-white/20 px-3 py-1.5">Mark Paid</button>}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
